import { z } from 'zod';

export const itemLevelSchema = z.object({
  id: z.number().int().positive(),
  name: z.string(),
  level: z.number().int(),
});

export const itemTypeSchema = z.object({
  id: z.number().int().positive(),
  name: z.string(),
  description: z.string().optional(),
  color: z.string().optional(),
  icon: z.string().optional(),
  itemLevel: itemLevelSchema,
});

export const itemTypeDisplaySchema = z.object({
  id: z.number().int().positive(),
  name: z.string(),
  color: z.string().optional(),
  icon: z.string().optional(),
  itemLevel: itemLevelSchema,
});

export type ItemLevelDTO = z.infer<typeof itemLevelSchema>;
export type ItemTypeDTO = z.infer<typeof itemTypeSchema>;
export type ItemTypeDisplayDTO = z.infer<typeof itemTypeDisplaySchema>;
